<template>
  <div class="loginContainer">
    <!-- <div class="loginHeader clear" @click="toHome()">
      <img
        class="float-l"
        style="height: 0.4rem; margin: 0.29rem 0.4rem 0 0; cursor: pointer"
        src="@/images/common/logo.png"
        alt=""
      />
      <div class="float-l" style="font-size: 0.2rem; color: #636363">
        欢迎登录
      </div>
      <div class="float-r clear" style="font-size: 0.14rem; color: #848994">
        <img
          class="float-l"
          src="@/images/login/phone.png"
          alt=""
          style="width: 0.2rem; height: 0.2rem; margin: 0.4rem 0.05rem 0 0"
        />
        <div class="float-l">客户服务热线：0574-28931251</div>
      </div>
    </div>
    <div class="loginBody">
      <div class="loginBox">
        <div class="type clear">
          <div
            class="typeItem float-l"
            :class="type === 0 ? 'active' : ''"
            @click="changeType(0)"
          >
            我是客户
          </div>
          <div
            class="typeItem float-l"
            :class="type === 1 ? 'active' : ''"
            @click="changeType(1)"
          >
            我是供应商
          </div>
        </div>
        <div class="login-type">
          <div
            class="item"
            :class="loginType == 1 ? 'act' : ''"
            @click="changeLoginType(1)"
          >
            密码登录
          </div>
          <div
            class="item"
            :class="loginType == 2 ? 'act' : ''"
            @click="changeLoginType(2)"
          >
            短信登录
          </div>
        </div>
        <div v-show="loginType == 1">
          <el-input
            class="inputItem phone"
            placeholder="请输入手机号/账户名"
            v-model="phone"
          >
            <i
              slot="prefix"
              class="iconfont icon-user"
              style="color: #848994"
            ></i>
          </el-input>
          <el-input
            class="inputItem password"
            placeholder="请输入密码"
            v-model="password"
            @keyup.native.enter="userLogin()"
            show-password
          >
            <i
              slot="prefix"
              class="iconfont icon-lock"
              style="color: #848994"
            ></i>
          </el-input>
        </div>
        <div v-show="loginType == 2">
          <el-input
            class="inputItem phone"
            placeholder="请输入手机号码"
            v-model="tel"
          >
            <i
              slot="prefix"
              class="iconfont icon-shouji"
              style="color: #848994"
            ></i>
            <el-select
              v-model="quhao"
              style="height: 0.48rem; width: 80px"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="+86" value="+86"></el-option>
            </el-select>
          </el-input>
          <el-input
            class="inputItem password"
            placeholder="请输入验证码"
            v-model="msgcode"
            @keyup.native.enter="msgLogin()"
          >
            <i
              slot="prefix"
              class="iconfont icon-duanxinyanzhengma"
              style="color: #848994"
            ></i>

            <el-button slot="append" @click="getMsgCode">{{
              time ? time + "s后重新获取" : "获取验证码"
            }}</el-button>
          </el-input>
        </div>
        <div
          class="loginBtn"
          @click="loginType == 1 ? userLogin() : msgLogin()"
        >
          登录
        </div>
        <div class="otherBtn clear">
          <div class="float-l">
            还有没有账号？<span @click="toRegister()">立即注册</span>
          </div>
          <div class="float-r">
            <span @click="toForget()">忘记密码？</span>
          </div>
        </div>
        <div class="msg">
          我们为您提供帐号服务，在登录过程中会使用到您的帐号和网络信息提升登录体验。<span
            @click="serviceDeatailShow = true"
            >了解服务条款 >></span
          >
        </div>
      </div>
    </div>
    <div class="loginFooter">
      <div class="href">
        <span>用户协议</span>
        |
        <span>隐私权益</span>
        |
        <span>帮助中心</span>
      </div>
      <div class="copy">版权所有© 2021鲸宝科技有限公司浙ICP备20024206号-1</div>
    </div>
    <Verify
      @success="verifySuccess"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    />
    <customer-protocol v-model="serviceDeatailShow"></customer-protocol> -->
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import api from "@/utils/api";
import { encryption } from "@/utils/util";
import Verify from "@/components/verifition/Verify";
// import CustomerProtocol from "../../components/CustomerProtocol/CustomerProtocol.vue";
export default {
  data() {
    return {
      type: 0,
      phone: "",
      password: "",
      code: "",
      randomStr: "blockPuzzle",
      prevRoute: "",
      serviceDeatailShow: false,
      loginType: 1,
      quhao: 86,
      tel: "",
      msgcode: "",
      msgText: "",
      time: 0,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('3333333333333')
  //   console.dir(to)
  //   console.dir(from)
  //   next((vm) => {
  //     vm.prevRoute = from;
  //   });
  // },
  components: {
    Verify,
    // CustomerProtocol,
  },
  mounted() {
    if(!this.$route.params.type) return;
    this.type =this.$route.params.type

  },
  methods: {
    // 发送验证码
    getMsgCode() {
      if (!this.tel) {
        this.messageTooltip({
          showClose: false,
          message: "请输入正确的手机号！",
          duration: 3000,
          type: "warning",
        });
        return;
      }
      if (!this.time) {
        let that = this;
        axios
          .get("/ship/mobile/login/" + this.tel, null, {
            headers: {
              isToken: false,
              "TENANT-ID": "1",
              Authorization: "Basic c2hpcDpzaGlw",
            },
            // params: { randomStr, code, grant_type }
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.messageTooltip({
                showClose: false,
                message: "验证码发送成功，请注意查收",
                duration: 3000,
                type: "warning",
              });
              that.time = 60;
              that.interval = setInterval(() => {
                if (that.time > 0) {
                  that.time--;
                } else {
                  clearInterval(that.interval);
                }
              }, 1000);
            }
          });
      }
    },
    msgLogin() {
      if (this.tel === "") {
        this.messageTooltip({
          showClose: false,
          message: "请输入登录手机号码",
          duration: 1500,
          type: "warning",
        });
        return;
      }
      if (this.msgcode === "") {
        this.messageTooltip({
          showClose: false,
          message: "请输入登录验证码",
          duration: 1500,
          type: "warning",
        });
        return;
      }
      let params = {
        phone: this.tel,
        smsCode: this.msgcode,
      };
      if (this.type == 0) {
        // 客户登录
        axios
          .post(
            "/ship/shipcustomer/mobileRegister?phone=" +
              this.tel +
              "&smsCode=" +
              this.msgcode,
            params,
            {
              headers: {
                isToken: false,
                "TENANT-ID": "1",
                Authorization: "Basic c2hpcDpzaGlw",
              },
            }
          )
          .then((res) => {
            if (res.data.code === 0) {
              axios
                .post(
                  "/ship/shipcustomer/mobileCheckCode?phone=" +
                  this.tel +
                  "&smsCode=" +
                  this.msgcode,
                  params,
                  {
                    headers: {
                      isToken: false,
                      "TENANT-ID": "1",
                      Authorization: "Basic c2hpcDpzaGlw",
                    },
                  }
                ).then((res) => {
                if (res.data.code === 0) {
                  //登录数据
                  let grant_type = "sms";
                  // userType：0 客户  1 供应商
                  let dataObj = qs.stringify({
                    username: this.tel,
                    password: this.msgcode,
                    userType: this.type,
                  });
                  axios
                    .post(
                      "/auth/mobile/token/sms?mobile=SMS@" +
                      this.tel +
                      "&code=" +
                      this.msgcode +
                      "&grant_type=mobile" +
                      "&utype=0",
                      dataObj,
                      {
                        headers: {
                          isToken: false,
                          "TENANT-ID": "1",
                          Authorization: "Basic c2hpcDpzaGlw",
                        },
                      }
                    )
                    .then((res) => {
                      console.log(res);
                      let access_token = res.data.access_token;
                      let type = res.data.user_info.type;
                      localStorage.setItem("ship_token", access_token);

                      if (this.type === 0) {
                        api
                          .getCustomerMsg({ id: res.data.user_info.id })
                          .then((res) => {
                            if (res.code === 0) {
                              res.data.type = type;
                              localStorage.setItem(
                                "ship_user",
                                JSON.stringify(res.data)
                              );
                              if (
                                this.prevRoute &&
                                this.prevRoute.name &&
                                this.prevRoute.name.indexOf("forget") != -1
                              ) {
                                this.$router.push({ path: "/" });
                              } else {
                                this.$router.go(-1);
                              }
                            }
                          });
                      }
                    });
                }

              });

            } else {
              // this.messageTooltip({
              //   showClose: false,
              //   message: res.data.msg,
              //   duration: 1500,
              //   type: 'error'
              // })
            }
          });
      }

      if (this.type == 1) {
        //供应商登录
        axios
          .post(
            "/ship/shipsupplier/mobileRegister?phone=" +
              this.tel +
              "&smsCode=" +
              this.msgcode,
            params,
            {
              headers: {
                isToken: false,
                "TENANT-ID": "1",
                Authorization: "Basic c2hpcDpzaGlw",
              },
            }
          )
          .then((res) => {
            if (res.data.code === 0) {
              axios
                .post(
                  "/ship/shipsupplier/mobileCheckCode?phone=" +
                  this.tel +
                  "&smsCode=" +
                  this.msgcode,
                  params,
                  {
                    headers: {
                      isToken: false,
                      "TENANT-ID": "1",
                      Authorization: "Basic c2hpcDpzaGlw",
                    },
                  }
                )
                .then((res) => {
                  if (res.data.code === 0) {
//登录数据
                    let grant_type = "sms";
                    // userType：0 客户  1 供应商
                    let dataObj = qs.stringify({
                      username: this.tel,
                      password: this.msgcode,
                      userType: this.type,
                    });
                    axios
                      .post(
                        "/auth/mobile/token/sms?mobile=SMS@" +
                        this.tel +
                        "&code=" +
                        this.msgcode +
                        "&grant_type=mobile" +
                        "&utype=1",
                        dataObj,
                        {
                          headers: {
                            isToken: false,
                            "TENANT-ID": "1",
                            Authorization: "Basic c2hpcDpzaGlw",
                          },
                        }
                      )
                      .then((res) => {
                        console.log(res);
                        let access_token = res.data.access_token;
                        let type = res.data.user_info.type;
                        localStorage.setItem("ship_token", access_token);

                        if (this.type === 1) {
                          api
                            .getSupplierMsg({ id: res.data.user_info.id })
                            .then((res) => {
                              if (res.code === 0) {
                                res.data.type = type;
                                localStorage.setItem(
                                  "ship_user",
                                  JSON.stringify(res.data)
                                );
                                if (
                                  this.prevRoute &&
                                  this.prevRoute.name &&
                                  this.prevRoute.name.indexOf("forget") != -1
                                ) {
                                  this.$router.push({ path: "/" });
                                } else {
                                  this.$router.go(-1);
                                }
                              }
                            });
                        }
                      });
                  }
                });

            } else {
              // this.messageTooltip({
              //   showClose: false,
              //   message: res.data.msg,
              //   duration: 1500,
              //   type: 'error'
              // })
            }
          });
      }
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
    toRegister() {
      this.$router.replace({ path: "/register" });
    },
    toForget() {
      this.$router.replace({ path: "/forget" });
    },
    changeType(type) {
      this.type = type;
    },
    userLogin() {
      let phone = this.phone;
      let password = this.password;
      if (phone === "") {
        this.messageTooltip({
          showClose: false,
          message: "手机号/账户名不能为空",
          duration: 1500,
          type: "warning",
        });
        return;
      }
      if (password === "") {
        this.messageTooltip({
          showClose: false,
          message: "密码不能为空",
          duration: 1500,
          type: "warning",
        });
        return;
      }
      this.$refs.verify.show();
    },
    changeLoginType(res) {
      this.loginType = res;
    },
    verifySuccess(params) {
      const user = encryption({
        data: {
          username: this.phone,
          password: this.password,
          code: params.captchaVerification,
          randomStr: "blockPuzzle",
        },
        key: "pigxpigxpigxpigx",
        param: ["password"],
      });
      this.loginByUsername(
        user.username,
        user.password,
        user.code,
        user.randomStr
      );
    },
    loginByUsername(username, password, code, randomStr) {
      let grant_type = "password";
      // userType：0 客户  1 供应商
      let dataObj = qs.stringify({
        username: username,
        password: password,
        userType: this.type,
      });
      axios
        .post("/auth/oauth/token", dataObj, {
          headers: {
            isToken: false,
            "TENANT-ID": "1",
            Authorization: "Basic c2hpcDpzaGlw",
          },
          params: { randomStr, code, grant_type },
        })
        .then((res) => {
          let access_token = res.data.access_token;
          let type = res.data.user_info.type;
          localStorage.setItem("ship_token", access_token);
          localStorage.setItem("tigs", true);
          if (this.type === 0) {
            api.getCustomerMsg({ id: res.data.user_info.id }).then((res) => {
              if (res.code === 0) {
                res.data.type = type;
                localStorage.setItem("ship_user", JSON.stringify(res.data));
                if (
                  this.prevRoute &&
                  this.prevRoute.name &&
                  this.prevRoute.name.indexOf("forget") != -1
                ) {
                  this.$router.push({ path: "/" });
                } else {
                  this.$router.go(-1);
                }
              }
            });
          }
          if (this.type === 1) {
            api.getSupplierMsg({ id: res.data.user_info.id }).then((res) => {
              if (res.code === 0) {
                res.data.type = type;
                localStorage.setItem("ship_user", JSON.stringify(res.data));
                if (
                  this.prevRoute &&
                  this.prevRoute.name &&
                  this.prevRoute.name.indexOf("forget") != -1
                ) {
                  this.$router.push({ path: "/" });
                } else {
                  this.$router.go(-1);
                }
              }
            });
          }
        })
        .catch((error) => {
          this.messageTooltip({
            showClose: false,
            message: "用户名或密码错误",
            duration: 1500,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.loginContainer {
  background: #fff;
}
.loginHeader {
  width: 12rem;
  margin: 0 auto;
  height: 0.98rem;
  line-height: 0.98rem;
}
.loginBody {
  height: 8.8rem;
  /* background: #9abce7 url("../../images/login/login_bg.png") no-repeat center; */
  background-size: cover;
  position: relative;
}
.loginBox {
  width: 5rem;
  height: 5rem;
  background: #fff;
  border-radius: 0.04rem;
  position: absolute;
  right: calc(50% - 6rem);
  top: 40%;
  margin-top: -2.25rem;
}
.loginBox .type {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #f9fbff;
}
.loginBox .type .typeItem {
  width: 50%;
  text-align: center;
  color: #636363;
  font-size: 0.16rem;
  cursor: pointer;
}
.loginBox .type .typeItem.active {
  font-size: 0.24rem;
  color: #376bf6;
  position: relative;
}
/* .loginBox .type .typeItem.active::after{
  content: '';
  position: absolute;
  bottom: .03rem;
  left: 50%;
  width: .81rem;
  height: .03rem;
  margin-left: -.405rem;
  background: #376BF6;
} */
.loginBox .inputItem {
  width: 4.2rem;
  margin: 0 0.4rem;
}
.loginBox .phone {
  margin-top: 0.4rem;
}
.loginBox .password {
  margin-top: 0.2rem;
}
.loginBox .loginBtn {
  width: 4.2rem;
  height: 0.48rem;
  line-height: 0.48rem;
  background: #376bf6;
  border-radius: 2px;
  font-size: 0.16rem;
  text-align: center;
  margin: 0.2rem 0.4rem 0 0.4rem;
  color: #fff;
  cursor: pointer;
}
.loginBox .otherBtn {
  margin: 0.2rem 0.4rem 0 0.4rem;
  font-size: 0.16rem;
  color: #848994;
}
.loginBox .otherBtn span {
  cursor: pointer;
}
.loginBox .otherBtn .float-l span {
  color: #376bf6;
}
.loginBox .msg {
  font-size: 0.16rem;
  color: #848994;
  margin: 0.4rem 0.4rem 0 0.4rem;
}
.loginBox .msg span {
  color: #376bf6;
  cursor: pointer;
}
.loginFooter {
  text-align: center;
  padding: 0.2rem 0;
  color: #848994;
}
.loginFooter .href {
  margin-bottom: 0.1rem;
}
.loginFooter .href span {
  margin: 0 0.1rem;
}
</style>
<style>
.loginContainer .el-input__prefix {
  margin-top: 0.16rem !important;
  margin-left: 0.05rem !important;
}
.loginContainer .el-input__inner {
  height: 0.48rem !important;
  background: #f4f3f1 !important;
}
.flex {
  display: flex;
}
.login-type {
  display: flex;
  padding: 10px 0.4rem 0;
}
.login-type .item {
  flex: 1;
  text-align: center;
  height: 0.4rem;
  position: relative;
}
.login-type .item.act {
  color: #376bf6;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}
.login-type .item.act::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  border: 5px solid transparent;
  border-color: transparent transparent #ccc transparent;
}

.loginContainer .el-input__inner:focus {
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue